"use client";

import React, {Suspense} from "react";
import {cn} from "@/lib/utils";
import FormattedDate from "@/components/global/countdown/FormattedDate";
import {useCountdown} from "@/lib/utilHooks";
import {useEffect} from "react";

export default function Countdown({
  dateTimeString,
  className,
}: {
  dateTimeString: string;
  className?: string;
}) {
  const { days, hours, minutes, seconds } = useCountdown(dateTimeString);

  useEffect(() => {
    console.log("dateTimeString", dateTimeString);
  }, [dateTimeString]);

  return (
    <div
      className={cn(
        "flex flex-col justify-center items-center gap-[2rem]",
        className
      )}
    >
      <div className="w-full flex justify-center items-center">
        <Suspense
          fallback={
            <p className="text-white/90 text-[1.75rem] lg:text-[2.25rem] leading-none mb-0">
              Loading.
            </p>
          }
        >
          <p className="countdownEnd text-white/80 text-[1.75rem] lg:text-[2rem] leading-none mb-0">
            <FormattedDate
              dateTimeString={dateTimeString}
              format="DD.MM.YYYY - HH:mm"
            />{" "}
            Uhr
          </p>
        </Suspense>
      </div>

      <div className="countdownContainer flex items-center gap-[1rem]">
        <div className="flex flex-col items-center justify-center gap-[.5rem] lg:gap-[1rem] min-w-[9rem] md:min-w-[10rem]">
          <p className="countdownText mb-0 text-white text-[6rem] sm:text-[7rem] font-semibold leading-none tabular-nums">{days}</p>
          <p className="mb-0 text-white/60 text-[1.75rem] leading-none">Tage</p>
        </div>

        <div className="flex flex-col">
          <p className="mb-0 text-white/50 font-semibold text-[4rem] leading-none">:</p>
        </div>

        <div className="flex flex-col items-center justify-center gap-[.5rem] lg:gap-[1rem] min-w-[9rem] md:min-w-[10rem]">
          <p className="countdownText mb-0 text-white text-[6rem] sm:text-[7rem] font-semibold leading-none tabular-nums">{hours}</p>
          <p className="mb-0 text-white/60 text-[1.75rem] leading-none">Stunden</p>
        </div>

        <div className="flex flex-col">
          <p className="mb-0 text-white/50 font-semibold text-[4rem] leading-none">:</p>
        </div>

        <div className="flex flex-col items-center justify-center gap-[.5rem] lg:gap-[1rem] min-w-[9rem] md:min-w-[10rem]">
          <p className="countdownText mb-0 text-white text-[6rem] sm:text-[7rem] font-semibold leading-none tabular-nums">{minutes}</p>
          <p className="mb-0 text-white/60 text-[1.75rem] leading-none">Minuten</p>
        </div>

        <div className="flex flex-col">
          <p className="mb-0 text-white/50 font-semibold text-[4rem] leading-none">:</p>
        </div>

        <div className="flex flex-col items-center justify-center gap-[.5rem] lg:gap-[1rem] min-w-[9rem] md:min-w-[10rem]">
          <p className="countdownText mb-0 text-white text-[6rem] sm:text-[7rem] font-semibold leading-none tabular-nums">{seconds}</p>
          <p className="mb-0 text-white/60 text-[1.75rem] leading-none">Sekunden</p>
        </div>
      </div>
    </div>
  );
}
